import React from 'react';
import './Leadermessage.css';
import useIntersectionObserver from '../useIntersectionObserver'; // Import the hook
import abhinav from "../../Assets/abhinav1.png"
import swati from "../../Assets/Swati.jpg"
// --- Image Placeholders (Keep or replace) ---
const swatiImage = swati
const abhinavImage = abhinav

const directorsData = [
   {
    id: "abhinav",
    name: "Abhinav Sen",
    title: "Director, Adhvik & Adhrit",
    image: abhinavImage,
    message: `At Adhvik & Adhrit, we believe that the foundation of every successful organization lies in its people—and the strategies that support them. Our core focus is on delivering best-in-class consultancy and manpower solutions that enable our clients to lead with confidence, agility, and purpose.\n\nAs industries continue to evolve, the need for forward-thinking workforce strategies and operational insight has never been greater. We align ourselves closely with our clients to understand their unique challenges and provide customized solutions that go beyond staffing—we help architect long-term success.\n\nWhat sets us apart is our commitment to excellence, transparency, and impactful partnerships. At Adhvik & Adhrit, we are proud to stand beside our clients as strategic allies, shaping organizations that are not only equipped for today but ready for tomorrow.`
  },
  {
    id: "swati",
    name: "Swati",
    title: "Director, Adhvik & Adhrit",
    image: swatiImage,
    message: `In today’s dynamic business landscape, our purpose at Adhvik & Adhrit remains resolute: to empower organizations with exceptional consultancy and manpower solutions that drive sustainable success. We understand that true operational excellence is not achieved through systems alone, but through people, strategy, and partnership.\n\nOur commitment goes beyond simply fulfilling requirements—we aim to build enduring collaborations that foster growth, enhance capability, and prepare our clients to thrive in an ever-evolving world. Through tailored solutions, continuous learning support, and innovative tools, we help businesses unlock their full potential.\n\nAt Adhvik & Adhrit, we don’t just provide services—we deliver transformation. Rooted in integrity, trust, and a deep understanding of organizational needs, we are proud to be shaping a future where companies are powered by the right talent and guided by strategic clarity.`
  }
 
];

// Component for individual director section to use the hook
const DirectorSection = ({ director, index }) => {
  const [elementRef, isVisible] = useIntersectionObserver({
    threshold: 0.1 // Trigger when 10% of the element is visible
  });

  return (
    <section
      ref={elementRef}
      className={`director-section ${index % 2 === 0 ? 'layout-normal' : 'layout-reversed'} ${isVisible ? 'is-visible' : ''}`}
      id={`director-${director.id}`}
    >
      <div className="director-image-container">
        <div className="director-image-bg-shape"></div>
        <img src={director.image} alt={`Director ${director.name}`} className="director-image" />
      </div>
      <div className="director-content">
        <h2 className="director-greeting">
          Director Voice
        </h2>
        <div className="message-text">
          {director.message.split('\n\n').map((paragraph, i) => ( // Split by double newline for paragraphs
            <p key={i}>{paragraph.trim()}</p>
          ))}
        </div>
        <p className="director-signature">
          — {director.name}
          <br />
          <span className="director-title-signature">{director.title}</span>
        </p>
      </div>
    </section>
  );
};


function Leadermessage() {
  return (
    <div className="directors-page-wrapper">
      {/* <header className="page-header">
        <div className="header-content">
          <h1 className="animate-pop-in">Voices of Leadership</h1>
          <p className="subtitle animate-fade-in-delay">
            Insights from the helm of Adhvik & Adhrit
          </p>
        </div>
        <div className="header-decoration"></div>
      </header> */}

      <main className="directors-container">
        {directorsData.map((director, index) => (
          <DirectorSection key={director.id} director={director} index={index} />
        ))}
      </main>

    
    </div>
  );
}

export default Leadermessage;